import { render, staticRenderFns } from "./EditIndicatorPerformance.vue?vue&type=template&id=cea28978&scoped=true&"
import script from "./EditIndicatorPerformance.vue?vue&type=script&lang=js&"
export * from "./EditIndicatorPerformance.vue?vue&type=script&lang=js&"
import style0 from "./EditIndicatorPerformance.vue?vue&type=style&index=0&id=cea28978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea28978",
  null
  
)

export default component.exports